/**
 * Created by maofaming on 2017/4/24.
 */

import QuRequest from '@/core/QuRequest';
import q from 'q';

const quRequest = new QuRequest();

const MARK = {
    TAG: -1,
    TEXT: 1,
    HIGH: 2,
    MULTI: 3
};

const SENSITIVE_MARK = 's-high';
const SENSITIVE_MULTI = 's-multiple';

function unDeckContent (content) {
    return (content || '').replace(/(data-)src=(?:"|').*?(?:"|')|(data-size=".*?")/gi, function (match, $1, $2) {
        return match.replace($1, '').replace($2, '');
    });
}

function replaceDetailImg (detail) {
    // data-src替换src
    if (detail) {
        return detail.replace(/<img[\s\S]+?(data-src)=/g, function (a, b) {
            return a.replace('data-src', 'src');
        });
    }
}

function escapeToHtml (str) {
    let arrEntities = { lt: '<', gt: '>', nbsp: ' ', amp: '&', quot: '"' };
    return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
        return arrEntities[t];
    });
}

/**
 * @param {string} wrap 必须还有 $word$ 关键字,用于标示替换词
 * @param {arrary} words 敏感词
 * @param {string} content 文本内容
 * @return {string} 替换后的文本
 */

function highSub (item, isShowOrigin) {
    let word = item.word;
    let list = item.subwordpos;
    if (list && list.length > 0) {
        let size = list.length;
        let multi = size > 1 ? SENSITIVE_MULTI : '';
        let resultTxt = '';
        let preIndex = 0;
        let index = 0;
        while (index < size) {
            let wordPos = list[index];
            let normal = word.substring(preIndex, wordPos[0]);
            let sensitive = word.substring(wordPos[0], wordPos[1]);
            resultTxt += `${normal}<span class="${SENSITIVE_MARK} ${multi}">${sensitive}</span>`;
            preIndex = wordPos[1];
            index++;
        }
        if (isShowOrigin && item.word !== item.org_word) {
            resultTxt += `【<span class="${SENSITIVE_MARK} ${multi}">${item.org_word}</span>】`;
        }
        resultTxt += word.substring(preIndex, word.length);
        return resultTxt;
    }
    return word;
}

function pureContent (content) {
    // let patt = /(?:<\w+(?:"[^"]*"|[^>])*>|<\/\w+>|[^<>]+)/i;
    let patt = /(?:<\w+(?:"[^"]*"|[^>])*>|<\/\w+>|[^<>]+)/g;
    let tag = /<(?:.|\s)*?>/;
    let result;
    let array = [];
    while ((result = patt.exec(content)) !== null) {
        if (!tag.test(result)) {
            // 是标签
            array.push([result.index, patt.lastIndex]);
        }
    }
    return array;
}

function clearTag (content) {
    // 使用时需要保证标签没有嵌套
    let patt = /(?:<\w+(?:"[^"]*"|[^>])*>|<\/\w+>|[^<>]+)/g;
    let startTag = new RegExp(`<span.*?(${SENSITIVE_MARK}|style=).*?>`); // 清除添加的敏感词标签及contenteditable增加的span
    let endTag = /<\/span>/;
    let isStart = false;
    let array = [];
    let result;
    while ((result = patt.exec(content)) !== null) {
        if (
            (!isStart && startTag.test(result)) || // 清除敏感词标记标签
            (isStart && endTag.test(result))
        ) {
            isStart = !isStart;
            continue;
        }
        array.push(result);
    }
    return array.join('');
}

function highWord (content, words) {
    // content = escapeToHtml(content)
    // content = content.replace(/\r\n\r\n/g, '<br>');
    // content = content.replace(/\r\n\s\s/g, '<br>');
    // content = content.replace(/\r\s\s\s/g, '<br>');
    // content = content.replace(/\n/g, '♥');

    let tagArray = pureContent(content);

    let markArray = [];
    let index = 0;
    for (let ch in content) {
        // 默认标记内容都标记为标签类型
        markArray[index] = MARK.TAG;
        index++;
    }

    tagArray.forEach(tagItem => {
        // 标记出内容中的文本
        for (let i = tagItem[0], end = tagItem[1]; i < end; i++) {
            markArray[i] = {
                type: MARK.TEXT,
                level: 0
            };
        }
    });

    if (words.length > 0) {
        // 标记敏感词
        words.forEach(wordItem => {
            let start = wordItem.start;
            let sub = wordItem.subwordpos || [];
            let type = sub.length > 1 ? MARK.MULTI : MARK.HIGH;
            let level = wordItem.level;
            sub.forEach(subItem => {
                for (let i = subItem[0], end = subItem[1]; i < end; i++) {
                    let index = start + i;
                    if (markArray[index] !== MARK.TAG) {
                        if (type === MARK.HIGH && markArray[index] === MARK.TEXT) {
                            markArray[index] = {
                                type: MARK.HIGH,
                                level: level
                            };
                        } else {
                            markArray[index] = {
                                type: type,
                                level: level
                            };
                        }
                    }
                }
            });
        });
    }

    let result = [];
    let preWord = MARK.TEXT;
    let isMark = false;
    index = 0;
    for (let word of content) {
        // 返回新的被标记敏感词内容
        // for(let i= 0, len = content.length; i < len; i++) {
        let i = index;
        if (markArray[i]) {
            let type = markArray[i].type;
            let level = markArray[i].level;
            if (preWord !== type && isMark) {
                // 内容标记改变且已经被标记时
                result.push('</span>');
                isMark = false;
            }

            // 内容被标记
            if (preWord !== MARK.HIGH && type === MARK.HIGH) {
                // 标记普通敏感词
                result.push(`<span class="${SENSITIVE_MARK}">`);
                isMark = true;
            } else if (preWord !== MARK.MULTI && type === MARK.MULTI) {
                // 标记复合
                result.push(`<span class="${SENSITIVE_MARK} ${SENSITIVE_MULTI}">`);
                isMark = true;
            }

            preWord = type;
        } else {
            preWord = MARK.TAG;
        }
        result.push(word);

        index++;
    }
    if (isMark) {
        result.push('</span>');
    }
    let str = result.join('');
    // str = str.replace(/\r\n\r\n/g, '<br>');
    // str = str.replace(/\r\n/g, '<br>');
    // str = str.replace(/\r/g, '<br>');
    str = str.replace(/\n/g, '<br>');
    // content = content.replace(/\n/g, '♥');
    // str = str.replace(/♥/g, '<br>');
    return str;
    // return result.join('');
}

function sensitiveHigh (obj, param, type) {
    let list = [];
    let requestArray = [];
    if (Object.prototype.toString.call(param) === '[object Array]') {
        list = param;
    } else {
        list = [param];
    }
    list.forEach(item => {
        if (item && obj[item]) {
            let content = obj[item];
            requestArray.push(
                quRequest
                    .send(quRequest.Apis.qupost.contentAudit.checkSensitiveWord, {
                        type: type,
                        content: content
                    })
                    .then(res => {
                        obj[item] = highWord(content, res.data.words);
                        return res.data && res.data.action;
                    })
            );
        }
    });

    return q
        .all(requestArray)
        .then(
            res => {
                res = res || [];
                let status = '';
                for (let i = 0, len = res.length; i < len; i++) {
                    let item = res[i];
                    if (item.indexOf('confirm') > -1) {
                        status = 'confirm';
                        break;
                    } else if (item.indexOf('highlight') > -1) {
                        status = 'highlight';
                    } else {
                        status = status || '';
                    }
                }
                return status;
            },
            res => {
                throw new Error(res.message || '未知错误');
            }
        )
        .catch(reason => {
            throw reason;
        });
}
function sensitiveRemoval (arr) {
    let array = [];
    let ob = {};
    arr.forEach(item => {
        if (!ob.hasOwnProperty(item.word) && ob[item.word] !== item.subwordpos.length) {
            ob[item.word] = item.subwordpos.length;
            array.push(item);
        }
    });
    return array;
}
// 新机审   －－－－胡配方－－－

// 敏感词替换
function specialText (word) {
    // 问题关键字特殊字符
    let regList = ['(', ')', '?', '.', '[', ']', '$', '+', '|', '^', '*'];
    regList.forEach(key => {
        if (word.includes(key)) {
            word = word.replace(new RegExp('\\' + key, 'g'), `\\${key}`);
        }
    });
    return word;
}

// 过滤一样的数据
function fomatData (data) {
    let obj = {};
    let _result = [];
    data.forEach((item, index) => {
        if (!obj[item.word]) {
            obj[item.word] = 'true';
            _result.push(item);
        }
    });
    if (_result.length) {
        // 按长度排序
        _result.sort((a, b) => {
            let aWord = (a.word && a.word.length) || 0;
            let bWord = (b.word && b.word.length) || 0;
            return bWord - aWord;
        });
    }
    return _result;
}

// 全角转成半角
function escapeCode2 (str) {
    let result = '';
    let code = '';
    for (let i = 0; i < str.length; i++) {
        code = str.charCodeAt(i); // 获取当前字符的unicode编码
        if (code >= 65281 && code <= 65373) {
            // 在这个unicode编码范围中的是所有的英文字母已经各种字符
            let d = str.charCodeAt(i) - 65248;
            result += String.fromCharCode(d); // 把全角字符的unicode编码转换为对应半角字符的unicode码
        } else if (code == 12288) {
            // 空格
            let d = str.charCodeAt(i) - 12288 + 32;
            result += String.fromCharCode(d);
        } else {
            result += str.charAt(i);
        }
    }
    return result;
}

// 文字高亮加span 标签
function highWordResult (item, word) {
    let resultTxt = '';
    let subwordpos = item.subwordpos || [];
    let size = subwordpos.length;
    // 匹配关键字正则
    let multi = size > 1 ? SENSITIVE_MULTI : '';
    let index = 0;
    let preIndex = 0;
    let spanStr = '';
    while (index < size) {
        let wordPos = subwordpos[index];
        let normal = word.substring(preIndex, wordPos[0]);
        let sensitive = word.substring(wordPos[0], wordPos[1]);
        spanStr = `<span class="${SENSITIVE_MARK} ${multi}">`;
        resultTxt += `${normal}<span class="${SENSITIVE_MARK} ${multi}">${sensitive}</span>`;
        preIndex = wordPos[1];
        index++;
    }
    resultTxt += word.substring(preIndex, word.length);
    return {
        txt: resultTxt,
        spanStr: spanStr
    };
}

// 文章内容文字高亮
function highContentWord (detail, data) {
    if (!Array.isArray(data)) {
        return detail;
    }
    const imgReg = new RegExp(`(<img.*?>)`, 'g');
    detail = escapeToHtml(detail);
    const imgArr = detail.match(imgReg) || [];
    let newDetail = detail.replace(imgReg, '__I__');
    let _result = fomatData(data);

    for (let k = 0; k < _result.length; k++) {
        let htmTag = new RegExp('<.*?>', 'ig'); // 匹配html元素
        let num = -1;
        let aHtml = newDetail.match(htmTag); // 存放html元素的数组
        newDetail = newDetail.replace(htmTag, '{~}'); // 替换html标签
        let item = _result[k];
        let word = item.word;
        let _word = word;
        // 不处理图片
        if (
            word == 'I' ||
            word == '_' ||
            word == '__' ||
            word == '_I' ||
            word == '__I' ||
            word == 'I_' ||
            word == 'I__' ||
            word == '{' ||
            word == '{~' ||
            word == '~' ||
            word == '~}' ||
            word == '}'
        ) {
            continue;
        }
        if (newDetail && newDetail.includes(word) && word) {
            //  特殊字符转译
            word = specialText(word);
            // 匹配关键字正则
            let replaceReg;
            try {
                // regList.push(word)

                replaceReg = new RegExp(word, 'g');
            } catch (e) {
                continue;
            }
            // 高亮文字
            let resultObj = highWordResult(item, _word);
            newDetail = newDetail.replace(replaceReg, resultObj.txt);
        }
        newDetail = newDetail.replace(/{~}/g, function () {
            // 恢复html标签
            num++;
            return aHtml[num];
        });
    }
    for (let i = 0; i < imgArr.length; i++) {
        newDetail = newDetail.replace('__I__', imgArr[i]);
    }
    return newDetail;
}

// 图集类容文字高亮
function pictureHighContentWord (list = [], data) {
    for (let i = 0, len = list.length; i < len; i++) {
        let _list = list[i];
        let desc = _list.desc;
        if (!desc) {
            break;
        }
        desc = escapeCode2(desc);
        let _result = fomatData(data);
        for (let k = 0; k < _result.length; k++) {
            let item = _result[k];
            let word = item.word;
            let _word = word;
            if (desc && desc.includes(word) && word) {
                // 匹配关键字正则
                // 正则转换
                word = specialText(word);
                let replaceReg;
                try {
                    replaceReg = new RegExp(word, 'g');
                } catch (e) {
                    continue;
                }
                // 高亮文字
                let resultObj = highWordResult(item, _word);
                if (!resultObj.spanStr.includes(word)) {
                    desc = desc.replace(replaceReg, resultObj.txt);
                }
            }
        }
        _list.desc = desc;
    }
}

export default {
    unDeckContent,
    sensitiveHigh,
    highWord,
    highSub,
    clearTag,
    sensitiveRemoval,
    highContentWord,
    pictureHighContentWord,
    replaceDetailImg
};
